/**
 * Registro de tecla com DEDUPE por evento.
 *
 * No Phaser 4, o mesmo KeyboardEvent dispara o handler nomeado duas vezes de
 * forma INTERMITENTE (dependente do instante do frame) — medido no menu: 3
 * ações para 2 Enters físicos, ora dobrando o Enter, ora a seta. Um WeakSet
 * POR REGISTRO ignora a segunda visita do mesmo objeto de evento, sem
 * interferir em outros listeners legítimos do mesmo evento físico.
 */

import type Phaser from 'phaser'

export function onKey(
  keyboard: Phaser.Input.Keyboard.KeyboardPlugin,
  eventName: string,
  handler: (event: KeyboardEvent) => void,
): void {
  const processed = new WeakSet<KeyboardEvent>()
  keyboard.on(eventName, (event: KeyboardEvent) => {
    if (processed.has(event)) return
    processed.add(event)
    handler(event)
  })
}
